import http from "./request";

//  1、获取验证码图片
export const getImageCaptchaApi = (
  data: APITYPES.GetImageCaptchaParams
): Promise<APITYPES.GetImageCaptchaResponse> => {
  return http.post("/base/captcha", data);
};

//  2、发送验证码
export const sendVerificateCodeApi = (
  data: APITYPES.SendVerificateCodeParams
): Promise<APITYPES.SendVerificateCodeResponse> => {
  return http.post("/base/verification/send", data);
};

// 3、重置密码
export const resetPasswordApi = (
  data: APITYPES.ResetPasswordParams
): Promise<APITYPES.ResetPasswordResponse> => {
  return http.post("/account/password/reset", data);
};

// 4、验证身份并换发密码重置会话
export const verifyPasswordResetIdentityApi = (
  data: APITYPES.PasswordResetVerifyParams
): Promise<APITYPES.PasswordResetVerifyResponse> => {
  return http.post("/account/password/reset/verify", data);
};

// 5.获取公钥
export const getPublicKeyApi = (): Promise<APITYPES.GetPublicKeyResponse> => {
  return http.get("/v2/public-key");
};
